export const handleSubmitForm = (values, mutateUpload) => {
  const mobiles = (values.mobiles || []).map((m) => ({
    mobileBrandId: Number(m.mobileBrandId),
    mobileModelName: String(m.mobileModelName || '').trim(),
  }));

  const uploadData = {
    telephone: values.telephone,
    fullName: values.fullName,
    mobiles,
    channelBuyId: values.channelBuyId,
    productId: values.productId,
    invImage: values.invImage ? values.invImage[0] : null,
    packageImage: values.packageImage ? values.packageImage[0] : null,
  };

  mutateUpload(uploadData);
};
